import { render, staticRenderFns } from "./news_information_detail.vue?vue&type=template&id=54f2753e&scoped=true"
import script from "./news_information_detail.vue?vue&type=script&lang=js"
export * from "./news_information_detail.vue?vue&type=script&lang=js"
import style0 from "./news_information_detail.vue?vue&type=style&index=0&id=54f2753e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2753e",
  null
  
)

export default component.exports